import React from 'react';
import PropTypes from 'prop-types';

import IconButton from '@ey/canvascoreservices/IconButton';

const Button = ({...rest}) => <IconButton {...rest} />;

Button.propTypes = {};

export default Button;
